import { observer } from 'mobx-react';
import * as React from 'react';
import { formatText } from 'bernie-l10n';
import { withLocalization } from '@shared-ui/localization-context';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
export var ChangeSearchCollapsedButton = observer(withLocalization(function (props) {
  var searchQuery = props.searchQuery,
    localDateFormat = props.localDateFormat,
    l10n = props.l10n;
  var formatDateString = l10n.formatDateString,
    parseLocalDateString = l10n.parseLocalDateString,
    formatDate = l10n.formatDate;
  var location = searchQuery.location,
    startDate = searchQuery.startDate,
    endDate = searchQuery.endDate;
  var getFormattedDate = function (dateString) {
    var localDate = parseLocalDateString(dateString, {
      raw: localDateFormat
    });
    var isoFormattedDate = formatDate(localDate, {
      raw: 'yyyy-MM-dd'
    });
    return formatDateString(isoFormattedDate, {
      skeleton: 'MMMd'
    });
  };
  return React.createElement("button", {
    ref: props.searchFormTriggerRef,
    onClick: props.openSearchForm,
    className: "uitk-button-tertiary",
    "data-testid": "search-update-trigger"
  }, React.createElement(UitkLayoutGrid, {
    columns: 12,
    rows: 2,
    space: "one"
  }, React.createElement(UitkSpacing, {
    padding: {
      blockstart: 'two'
    }
  }, React.createElement(UitkLayoutGridItem, {
    colStart: 1,
    rowSpan: 2
  }, React.createElement("div", null, React.createElement(UitkIcon, {
    name: "search",
    size: UitkIconSize.MEDIUM
  })))), React.createElement(UitkLayoutGridItem, {
    rowSpan: 1,
    colStart: 2,
    colEnd: "end",
    justifySelf: "start"
  }, React.createElement(UitkText, {
    size: 500,
    "data-testid": "location",
    weight: "medium",
    className: "truncate min-width full-width"
  }, formatText('lx.search.playback.title', location))), React.createElement(UitkLayoutGridItem, {
    rowSpan: 1,
    colStart: 2,
    colEnd: "end",
    justifySelf: "start"
  }, React.createElement(UitkText, {
    size: 200,
    "data-testid": "start-and-end-date"
  }, startDate && getFormattedDate(startDate), " - ", endDate && getFormattedDate(endDate)))));
}));